export const FLIGHT_COMPANIES = [
  "Aegean Airlines",
  "Aer Lingus",
  "Aeroflot",
  "Aeromexico",
  "Air Canada",
  "Air China",
  "Air France",
  "Air India",
  "Air New Zealand",
  "AirAsia",
  "Alaska Airlines",
  "Alitalia",
  "All Nippon Airways (ANA)",
  "American Airlines",
  "Asiana Airlines",
  "Austrian Airlines",
  "Avianca",
  "British Airways",
  "Brussels Airlines",
  "Cathay Pacific",
  "China Eastern Airlines",
  "China Southern Airlines",
  "Delta Air Lines",
  "EasyJet",
  "Emirates",
  "Ethiopian Airlines",
  "Etihad Airways",
  "Finnair",
  "Frontier Airlines",
  "Gulf Air",
  "Hainan Airlines",
  "Hawaiian Airlines",
  "Iberia",
  "Icelandair",
  "Japan Airlines",
  "JetBlue Airways",
  "KLM Royal Dutch Airlines",
  "Korean Air",
  "LATAM Airlines",
  "Lufthansa",
  "Malaysia Airlines",
  "Norwegian Air",
  "Porter Airlines",
  "Qantas",
  "Qatar Airways",
  "Ryanair",
  "SAS Scandinavian Airlines",
  "Singapore Airlines",
  "Southwest Airlines",
  "Spirit Airlines",
  "Swiss International Air Lines",
  "TAP Air Portugal",
  "Thai Airways",
  "Turkish Airlines",
  "United Airlines",
  "Virgin Atlantic",
  "Vueling",
  "WestJet",
  "Wizz Air"
];

export const getFlightCompanies = () => FLIGHT_COMPANIES;

export const searchFlightCompanies = (query: string) => {
  if (!query) return FLIGHT_COMPANIES;
  
  return FLIGHT_COMPANIES.filter(company =>
    company.toLowerCase().includes(query.toLowerCase())
  );
};
